/**
 * Bundled invite config (same shape as public/AppData.json `data`).
 * Edit here for production; guest names still load from the API.
 * Regenerate from JSON: node scripts/genAppStaticData.js
 */
export const APP_STATIC_DATA = {
  "assetsVersion": 4,
  "settings": {
    "defaultLang": "en",
    "countdownTargetIso": "2026-08-08T19:00:00+03:00",
    "timeZone": "Asia/Beirut"
  },
  "display": {
    "slide1": {
      "husband": "en",
      "bride": "en",
      "ampersand": "en"
    },
    "slide2": {
      "husband": "en",
      "bride": "en",
      "ampersand": "en"
    }
  },
  "ui": {
    "welcome": {
      "en": "Welcome",
      "ar": "أهلاً وسهلاً",
      "lang": "en"
    },
    "startLines": {
      "en": [
        "Open",
        "your",
        "invitation"
      ],
      "ar": [
        "افتح",
        "دعوتك",
        ""
      ],
      "lang": "en"
    },
    "envelopeFeel": {
      "enabled": true,
      "sealLogoSrc": "/img/Logo.jpeg",
      "colors": {
        "paper1": "#5c4430",
        "paper2": "#785c44",
        "paper3": "#4a3426",
        "paperAlpha1": 0.52,
        "paperAlpha2": 0.46,
        "paperAlpha3": 0.55,
        "flapSide1": "#87694e",
        "flapSide2": "#5f4634",
        "flapSideAlpha1": 0.58,
        "flapSideAlpha2": 0.62,
        "flapBottom1": "#6e523c",
        "flapBottom2": "#553e2e",
        "flapBottomAlpha1": 0.6,
        "flapBottomAlpha2": 0.64,
        "flapTop1": "#967658",
        "flapTop2": "#694e3a",
        "flapTopAlpha1": 0.62,
        "flapTopAlpha2": 0.58,
        "kraftInsetShadow": "rgba(30, 18, 10, 0.28)",
        "sealHighlight": "rgba(110, 48, 52, 0.45)",
        "sealMid": "#5c2428",
        "sealDeep": "#451a20",
        "sealInk": "#2d1014",
        "sealVoid": "#160809",
        "sealEdge": "rgba(60, 28, 32, 0.5)",
        "sealRim": "rgba(25, 10, 12, 0.65)",
        "sealInsetTop": "rgba(95, 42, 48, 0.35)",
        "sealInsetBottom": "rgba(8, 2, 4, 0.75)",
        "sealInsetHighlight": "rgba(130, 72, 78, 0.12)",
        "sealRing": "rgba(140, 112, 62, 0.42)",
        "sealShine": "rgba(200, 150, 145, 0.22)",
        "textWelcome": "#f5ebe0",
        "textGuest": "#edd6c9",
        "textLine": "#e8dccf",
        "textLineLead": "#f0d6d8",
        "textHint": "rgba(232, 220, 207, 0.72)",
        "ornament": "rgba(45, 28, 18, 0.65)"
      }
    },
    "curtainFeel": {
      "enabled": false,
      "colors": {
        "fabric1": "rgba(120, 18, 28, 0.92)",
        "fabric2": "rgba(55, 8, 14, 0.94)",
        "fold": "rgba(255, 255, 255, 0.08)",
        "shadow": "rgba(0, 0, 0, 0.58)"
      }
    },
    "bookPageSwipe": {
      "enabled": false,
      "perspectivePx": 1180,
      "maxAngleDeg": 46,
      "depthPx": 24,
      "curve": 1.42,
      "cornerLiftDeg": 17,
      "hingeYPercent": 92,
      "easeExponent": 0.84,
      "curlExtraDeg": 14,
      "shadowStrength": 1,
      "foreshortenMin": 0.8
    },
    "leaves": {
      "enabled": true,
      "count": 18,
      "images": [
        "/img/realLeaf1.png",
        "/img/realLeaf2.png",
        "/img/realLeaf3.png",
        "/img/realLeaf4.png"
      ]
    },
    "swipeLeft": {
      "en": "SWIPE LEFT",
      "ar": "اسحب لليسار",
      "lang": "en"
    },
    "slide1": {
      "gettingMarried": {
        "en": "We Are Getting Married !",
        "ar": "يتشرفان بدعوتكم لحفل زفافهما",
        "lang": "en"
      },
      "countdownCaption": {
        "en": "Count down until the most special day of our lives",
        "ar": "العد التنازلي ليومنا المميز",
        "lang": "en"
      },
      "dateLine": {
        "en": "Saturday, August 8, 2026",
        "ar": "السبت ٨ آب ٢٠٢٦",
        "lang": "en"
      }
    },
    "countdownUnits": {
      "days": {
        "en": "Days",
        "ar": "يوم",
        "lang": "en"
      },
      "hours": {
        "en": "Hours",
        "ar": "ساعة",
        "lang": "en"
      },
      "minutes": {
        "en": "Minutes",
        "ar": "دقيقة",
        "lang": "en"
      },
      "seconds": {
        "en": "Seconds",
        "ar": "ثانية",
        "lang": "en"
      }
    },
    "countdownScratch": {
      "enabled": false,
      "coverText": {
        "en": "Scratch",
        "ar": "اكشط",
        "lang": "en"
      },
      "coverColor": "rgba(255,255,255,0.92)",
      "revealThreshold": 0.42,
      "brushRadiusPx": 14
    },
    "locationMap": {
      "en": "Location Map",
      "ar": "الموقع على الخريطة",
      "lang": "en"
    },
    "rsvp": {
      "accept": {
        "en": "Accept",
        "ar": "أقبل",
        "lang": "en"
      },
      "decline": {
        "en": "Decline",
        "ar": "اعتذر",
        "lang": "en"
      },
      "submit": {
        "en": "RSVP",
        "ar": "تأكيد الحضور",
        "lang": "en"
      }
    },
    "lastPage": {
      "lines": [
        {
          "en": "Your presence and prayers",
          "ar": "وجودكن فرحتنا!",
          "lang": "ar"
        }
      ],
      "logoSrc": "/img/Logo.jpeg",
      "tapFireworks": {
        "enabled": true,
        "showHint": true,
        "hint": {
          "en": "Tap anywhere for your own fireworks ✨",
          "ar": "اضغط في أي مكان لإطلاق الألعاب النارية ✨",
          "lang": "en"
        }
      },
      "fireworksBrightness": 1.2,
      "fireworksTapMax": 26
    },
    "ampersand": {
      "en": "&",
      "ar": "&",
      "lang": "en"
    }
  },
  "backgroundMusic": {
    "enabled": true,
    "src": "/audio/Music.mp3"
  },
  "globalBackgroundVideo": {
    "enabled": false,
    "src": "/video/Chris.mp4"
  },
  "startPageMedia": {
    "type": "image",
    "src": "/img/HomePage.jpg"
  },
  "slideMedia": {
    "slide1": {
      "type": "image",
      "src": "/img/Page1.jpg"
    },
    "slide2": {
      "type": "image",
      "src": "/img/Page2.jpg"
    },
    "slide3": {
      "type": "image",
      "src": "/img/Page3.jpg"
    },
    "slide4": {
      "type": "image",
      "src": "/img/Page4.jpg"
    },
    "slide5": {
      "type": "image",
      "src": "/img/Page5.jpg"
    },
    "slide6": {
      "type": "image",
      "src": "/img/Page6.jpg"
    },
    "groomHome": {
      "type": "image",
      "src": "/img/GroomHome.jpg"
    },
    "brideHome": {
      "type": "image",
      "src": "/img/BrideHome.jpg"
    }
  },
  "husband": {
    "en": "Elias",
    "ar": "إلياس"
  },
  "bride": {
    "en": "Elsy",
    "ar": "إلسي"
  },
  "bibleQuotes": {
    "en": "“Love makes the impossible possible.”",
    "ar": "«إنَّ الحُبَّ يَجعَل من الأُمور المستَحيلة مُمكِنة»",
    "lang": "ar"
  },
  "evangelist": {
    "en": "(Saint Rita)",
    "ar": "(القدّيسة ريتا)",
    "lang": "ar"
  },
  "marriageQuotes": {
    "en": [
      "Jean & Rima El Hajj",
      "&",
      "Roger & Sanaa El Chakhtoura",
      "",
      "With hearts full of joy, the families invite you to share the wedding celebration of their children."
    ],
    "ar": [
      "جان وريما الحاج",
      "و",
      "روجيه و سناء الشختورة",
      "",
      "بقلوبٍ يغمرها الفرح، يدعوكم الأهل لمشاركتهم حفل زفاف ولديهما"
    ],
    "lang": "ar"
  },
  "slide2Typography": {
    "fillPage": true,
    "compact": false
  },
  "slide2CeremonyLead": {
    "en": "",
    "ar": "وذلك نهار السبت الواقع فيه {date}",
    "lang": "ar"
  },
  "slide2CeremonySubline": {
    "en": "On Saturday the 8th of August, 2026",
    "ar": "السبت ٨ آب ٢٠٢٦",
    "lang": "en"
  },
  "ceremonyDateShort": {
    "en": "August 8, 2026",
    "ar": "٨ آب ٢٠٢٦"
  },
  "ceremony": {
    "title": {
      "en": "Wedding Ceremony",
      "ar": "القداس الإلهي",
      "lang": "en"
    },
    "dateLine": {
      "en": "On Saturday the 8th of August, 2026",
      "ar": "السبت ٨ آب ٢٠٢٦",
      "lang": "ar"
    },
    "time": {
      "en": "7:30 PM",
      "ar": "الساعة ٧:٣٠ مساءً",
      "lang": "ar"
    },
    "church": {
      "en": "Deir El Mokhallas Church",
      "ar": "في كنيسة مار روكز ",
      "lang": "ar"
    },
    "churchNote": {
      "en": "",
      "ar": "",
      "lang": "ar"
    },
    "location": {
      "en": "Hazmieh",
      "ar": "حازميه",
      "lang": "ar"
    },
    "googleMap": "https://maps.app.goo.gl/SNGBuPgwFEEhcoWq9?g_st=aw"
  },
  "thanksQuote": {
    "en": "Together, let's mark the beginning of forever!",
    "ar": "معاً نبدأ إلى الأبد!",
    "lang": "en"
  },
  "dinner": {
    "dinnerTitle": {
      "en": "Welcome Drink & Dinner",
      "ar": "حفل شرب وعشاء",
      "lang": "en"
    },
    "dinnerDate": {
      "en": "Following the ceremony — dinner celebration",
      "ar": "يلي الاكليل حفل عشاء",
      "lang": "ar"
    },
    "dinnerTime": {
      "en": "8:30 PM",
      "ar": "الساعة ٨:٣٠ مساءً",
      "lang": "ar"
    },
    "dinnerResto": {
      "en": "Byblos Palace",
      "ar": "في The Grandhouse ",
      "lang": "ar"
    },
    "dinnerLocation": {
      "en": "Byblos",
      "ar": "دكوانه مار روكز",
      "lang": "ar"
    },
    "dinnerGoogleMap": "https://maps.app.goo.gl/qWFShyWhE6y4KTci9?g_st=aw"
  },
  "gift": {
    "giftRegistryTitle": {
      "en": "Gift Registry",
      "ar": "قائمة الهدايا",
      "lang": "en"
    },
    "lines": [
      {
        "en": "For those who wish, the gift registry",
        "ar": "لمن يرغب، لائحة الهدايا",
        "lang": "ar"
      },
      {
        "en": "BOB FINANCE",
        "ar": "BOB FINANCE",
        "lang": "en"
      }
    ],
    "brandLogoSrc": "/img/image01.png",
    "accountLabel": {
      "en": "Account ID:",
      "ar": "رقم الحساب:",
      "lang": "en"
    },
    "giftRegistryID": "860054"
  },
  "rsvp": {
    "rsvpTitle": {
      "en": "Be Our Guest",
      "ar": "كن ضيفنا",
      "lang": "en"
    },
    "rsvpReplyDate": {
      "en": "Please confirm your attendance before July 28.",
      "ar": "يرجى تأكيد الحضور قبل ٢٨ تموز.",
      "lang": "ar"
    },
    "rsvpGreeting": {
      "en": "We are delighted to have you share our joy.",
      "ar": "يسعدنا أن تشركونا فرحتنا.",
      "lang": "ar"
    }
  },
  "scrollSinglePage": {
    "enabled": false,
    "scrollHint": {
      "en": "Scroll down",
      "ar": "مرّر لأسفل",
      "lang": "en"
    }
  },
  "calendarAdd": {
    "enabled": false,
    "includeDinner": true,
    "ceremonyDurationMinutes": 90,
    "dinnerDurationMinutes": 150,
    "dinnerOffsetMinutesFromCeremonyStart": 60,
    "dinnerStartIso": null,
    "showGoogleCalendar": true,
    "showIcsDownload": true,
    "ceremonyTitle": {
      "en": "Wedding ceremony",
      "ar": "قداس الزفاف",
      "lang": "en"
    },
    "ceremonyDescription": null,
    "dinnerTitle": {
      "en": "Wedding reception",
      "ar": "حفل العشاء",
      "lang": "en"
    },
    "dinnerDescription": null,
    "labels": {
      "ceremonyBadge": {
        "en": "Save the date",
        "ar": "احفظ التاريخ",
        "lang": "en"
      },
      "dinnerBadge": {
        "en": "Reception",
        "ar": "الحفل",
        "lang": "en"
      },
      "addGoogle": {
        "en": "Google Calendar",
        "ar": "تقويم جوجل",
        "lang": "en"
      },
      "addIcs": {
        "en": "Apple / Outlook (.ics)",
        "ar": "ملف التقويم (.ics)",
        "lang": "en"
      }
    }
  },
  "groomHome": {
    "enabled": true,
    "title": {
      "en": "Groom's Home",
      "ar": "منزل العريس",
      "lang": "en"
    },
    "location": {
      "en": "",
      "ar": "",
      "lang": "ar"
    },
    "googleMap": "https://maps.app.goo.gl/qGwSCVGFbLnsCDU69?g_st=aw",
    "locationOffsetPx": 40
  },
  "brideHome": {
    "enabled": true,
    "title": {
      "en": "Bride's Home",
      "ar": "منزل العروس",
      "lang": "en"
    },
    "location": {
      "en": "",
      "ar": "",
      "lang": "ar"
    },
    "googleMap": "https://maps.app.goo.gl/KXpfBMZvwmDAedhN6?g_st=aw"
  },
  "ceremonyDinnerMerged": {
    "enabled": true,
    "title": {
      "en": "Wedding Ceremony & Cocktail",
      "ar": "حفل الزفاف والكوكتيل",
      "lang": "en"
    },
    "dateLine": {
      "en": "Saturday, August 8, 2026",
      "ar": "السبت ٨ آب ٢٠٢٦",
      "lang": "ar"
    },
    "time": {
      "en": "7:00 PM",
      "ar": "الساعة ٧:٠٠ مساءً",
      "lang": "ar"
    },
    "location": {
      "en": "Mar Mikhael Church - Nahr",
      "ar": "في كنيسة مار ميخائيل - النهر",
      "lang": "ar"
    },
    "note": {
      "en": "Following the ceremony, a cocktail reception in the church courtyard",
      "ar": "ويلي الإكليل، حفل كوكتيل في باحة الكنيسة",
      "lang": "ar"
    },
    "googleMap": "https://maps.app.goo.gl/w9EfVA8yXjcs1coJA?g_st=aw"
  }
};
